export default "__VITE_ASSET__DueOpNd$__"